module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAbCAMAAABcI88jAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAABUUExURUdwTDJm/zNm/zJm/zJm/63I/zJl/zNl/zJm/zNm/053/zFk/zh2/zNm/zJm/zNl/zNm/zJl/6/K/7DJ/zFl/zRm/zJk/67J/67I/67J/zNm/67J/7GV8+0AAAAadFJOUwCR8MRueLic4PgTLAXVpkRVXFQ4fHZ63PGX6+SJXQAAAKZJREFUKM+9ktkSwiAMRS9Ladm6utL//0+BVoWp5k3PSyY5wwBJgCfLbd25Ghy5ry/mSphhkiOat14QC4PL0p10CIE7Nzc7M0wuTcn2IaOKC63fahdgDAQWgtIMnNICVeq978q8q7RO79K/0J1SKukY+FHzosuW1obW+HA3k1ImFYP6978TPWOi7rmmJ0bOu4Wk9AAnqMOxg/3XVdpW2Z5Ze4BJG9UD3Zs7KN53oHoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MallPage/biomedicine.png
// module id = sM1j
// module chunks = 0